import type { FaireProductEntity } from "../../entity_types/product";

export const p_rxdrt7hpn4: FaireProductEntity = {
  token: "p_rxdrt7hpn4",
  type: "product",
  name: "Sweet Wink Gold Bottom Hangers - 12 Pack - Children's Hanger",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/28d703a93dafba2b5ed868f72b752b7feece312bddcbd4fdc8e6acfc5b659fee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/143e605cded91e0a339ae96799828b38635688ceadbbcfd27d299a2ea5a94386.jpeg",
  ],
  priceDollars: 18,
  description:
    'These Sweet Wink Gold Bottom hangers are the perfect way to hang our magical tutus. Paired with the Sweet Wink Gold Top Hangers, you can be sure to have an elegant visual display.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Color: Gold\n• Dimensions: 12.6" wide, 7.9" tall\n• Quantity: 12\n• 2 adjustable clips\n• Engraved with the Sweet Wink logo',
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:29.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
